import { render, staticRenderFns } from "./setSettle.vue?vue&type=template&id=8e1dff0e&scoped=true&"
import script from "./setSettle.vue?vue&type=script&lang=js&"
export * from "./setSettle.vue?vue&type=script&lang=js&"
import style0 from "./setSettle.vue?vue&type=style&index=0&id=8e1dff0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1dff0e",
  null
  
)

export default component.exports